import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { login } from '../api/client'
import { useSession } from '../store/session'

export function Login() {
  const setSession = useSession((s) => s.setSession)
  const nav = useNavigate()
  const [service, setService] = useState('https://bsky.social')
  const [identifier, setIdentifier] = useState('')
  const [password, setPassword] = useState('')
  const [twofa, setTwofa] = useState('')
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState<string | null>(null)

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setBusy(true)
    setErr(null)
    try {
      const r = await login({
        service,
        identifier: identifier.replace(/^@/, '').trim(),
        password: password.trim(),
        authFactorToken: twofa.trim() || undefined,
      })
      setSession({
        service,
        did: r.did,
        handle: r.handle,
        accessJwt: r.accessJwt,
        refreshJwt: r.refreshJwt,
      })
      nav('/tiles')
    } catch (e) {
      setErr((e as Error).message)
    } finally {
      setBusy(false)
    }
  }

  return (
    <main className="mx-auto w-full max-w-md p-6">
      <h1 className="mb-1 text-2xl font-bold text-white">skypanel</h1>
      <p className="mb-4 text-xs text-ink-300">
        Sign in with a Bluesky app password (settings → app passwords).
        Tokens stay in your browser; the worker only proxies the login
        round-trip.
      </p>
      <form onSubmit={submit} className="glass-tinted space-y-3 p-4">
        <label className="block text-xs">
          <span className="text-ink-300">PDS / service</span>
          <input
            value={service}
            onChange={(e) => setService(e.target.value)}
            className="glass-input mt-1"
          />
        </label>
        <label className="block text-xs">
          <span className="text-ink-300">handle or email</span>
          <input
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
            className="glass-input mt-1"
            placeholder="alice.bsky.social"
            autoComplete="username"
          />
        </label>
        <label className="block text-xs">
          <span className="text-ink-300">app password</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="glass-input mt-1"
            placeholder="xxxx-xxxx-xxxx-xxxx"
            autoComplete="current-password"
          />
        </label>
        <label className="block text-xs">
          <span className="text-ink-300">2fa code (if your account uses one)</span>
          <input
            value={twofa}
            onChange={(e) => setTwofa(e.target.value)}
            className="glass-input mt-1"
            placeholder="optional"
          />
        </label>
        {err ? (
          <div className="rounded-md border border-rose-400/30 bg-rose-500/10 px-2 py-1 text-xs text-rose-100">
            {err}
          </div>
        ) : null}
        <button type="submit" disabled={busy} className="glass-button w-full">
          {busy ? 'signing in…' : 'sign in'}
        </button>
      </form>
    </main>
  )
}
